export const FULL_WIDTH_LINE_GRAPH_HEIGHT = 300;
